import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { OwnershipTransferCustomerStep, PopupEnum, RequestStatus, PopupMessageContent } from '../Constant/Constant';
import { setCurrentStep, setShowPopUp, setCurrentPopUp, setSelectedPricePlan } from '../OwnershipTransferCustomerSlice';
import SalePackages from '../../SalePackagesBlock/SalePackages';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'

const SelectPackage = (props) => {
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState('');
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails },
        actionType: DwhActionType.ChoosePackagePage,
        messageText: DWHMessageText.ChoosePackagePageDisplayed,
        status: DWHStatus.Ongoing
      });
    }
  }, []);

  function onSelectPackage(selectedPackage) {
    props.setSelectedPricePlan(selectedPackage);
  }

  function nextStep() {
    if (!props.data.selectedPricePlan && !props.serviceForm.serviceFormIsSign) {
      setErrorText('כדי להמשיך יש לבחור חבילה ולאשר את התנאים');
      setError(true);
    } else if (!props.data.selectedPricePlan && props.serviceForm.serviceFormIsSign) {
      setErrorText('כדי להמשיך יש לבחור חבילה');
      setError(true);
    } else if (props.data.selectedPricePlan && !props.serviceForm.serviceFormIsSign) {
      setErrorText('כדי להמשיך יש לאשר את תנאי החבילה');
      setError(true);
    } else {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails },
        actionType: DwhActionType.ChoosePackagePage,
        messageText: DWHMessageText.ChooseBanPageButtonClicked,
        status: DWHStatus.Ongoing
      });
      if (
        props.data.requestStatus == RequestStatus.SentForSignature ||
        props.data.requestStatus == RequestStatus.AwaitingContactPersonSignature
      ) {
        props.setCurrentPopUp({
          currentPopupData: PopupMessageContent.WaitingForCPSignature,
          currentPopUp: PopupEnum.CustomerValidationResult,
        });
      }
      else if (props.data.futureAbroadPackage) {
        props.setCurrentPopUp({
          currentPopupData: PopupMessageContent.FutureAbroadPackage,
          currentPopUp: PopupEnum.CustomerValidationResult,
        });
      } else {
        if (props.data.currentEquipmentObligations?.length > 0) {
          props.setCurrentStep(OwnershipTransferCustomerStep.EquipmentObligations);
        }
        else if (props.data.cellcomDu) {
          props.setCurrentStep(OwnershipTransferCustomerStep.CellcomDu);
        } else {
          props.setCurrentStep(OwnershipTransferCustomerStep.SubscriberPersonalData);
        }
      }
    }
  }
  return (
    <div className='ownership-transfer-select-package'>
      <div className='l-title'>עם איזו חבילה נתקדם?</div>
      <SalePackages
        packages={props.iContent.packagesList}
        onSelectedPackages={(newPackage) => onSelectPackage(newPackage)}
        oneTimeFee={false}
        isChangePricePlan={false}
        setBorder={true}
      />
      <div className='service-form-link'>
        <a onClick={() => props.setCurrentPopUp({ currentPopUp: PopupEnum.ServiceFormPopup })}>
          <Image src={props.serviceForm.serviceFormIsSign ? require('../Icons/check.svg') : require('../Icons/services-form-icon.svg')} />
          <div className='link-text'>לחצו כאן לחתימה על גישה לשירותים </div>
        </a>
      </div>
      <div className='continue-button'>
        {error && <div className='error center'>{errorText}</div>}
        <BtnSubmit onclick={nextStep} text={'בחרתי, אפשר להמשיך'} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferCustomer,
  serviceForm: state.serviceAccessForm,
  userDetails: state.authentication?.loginData?.userDetails,

});

const mapDispatchToProps = {
  setShowPopUp,
  setCurrentStep,
  setCurrentPopUp,
  setSelectedPricePlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectPackage);
